import React from "react";
import PropTypes from "prop-types";
import BondObligeeInformationBase from "../../shared/components/BondObligeeInformationBase";
import { getObligeeSurfaceConfig } from "../../shared/obligeeInformationConfig";
import { GoogleAutoComplete } from "../../shared/widgets";

export default function ObligeeInformation(props) {
  return (
    <BondObligeeInformationBase
      cfg={getObligeeSurfaceConfig("blanket")}
      GoogleAutoComplete={GoogleAutoComplete}
      {...props}
    />
  );
}

ObligeeInformation.propTypes = {
  control: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired,
  obligees: PropTypes.array,
  loadingObligees: PropTypes.bool,
  openObligeeDialog: PropTypes.bool.isRequired,
  setOpenObligeeDialog: PropTypes.func.isRequired,
  newObligee: PropTypes.object.isRequired,
  setNewObligee: PropTypes.func.isRequired,
  handleAddObligee: PropTypes.func.isRequired,
  handleObligeeGoogleCallback: PropTypes.func.isRequired,
  allCities: PropTypes.array,
  allStates: PropTypes.array,
};
